import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    initialized: false,
    list: new Map()
});
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'TESTBENCH__SET_ENV':
            return core.resetBoxListDetail(state);
        case 'TESTBENCH__SET_BOX_LIST':
            return core.setBoxList(state, action.boxes);
        case 'TESTBENCH__SET_BOX_LIST_FECHED':
            return core.setBoxListFetched(state, action.boxes);
        case 'TESTBENCH__SET_BOX_DETAIL':
            return core.setBoxListDetail(state, action.boxMac, action.box);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/testbench/data/Boxes/reducer.js